import { render } from "./PlantUML.vue?vue&type=template&id=212a432a"
import script from "./PlantUML.vue?vue&type=script&lang=js"
export * from "./PlantUML.vue?vue&type=script&lang=js"

import "./PlantUML.vue?vue&type=style&index=0&id=212a432a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__